import { TreeNode } from "primeng/api";
import { environment } from "../../../../../environments/environment";
import { SectionService } from "../../../service/section-service/section-service";
import { Art57Section } from "../../Art57Section/Art57Section";
import { DynamicListView } from "../../Data/DynamicListView";
import { PaginationControl } from "../../PaginationControl";
import { Util } from "../../Util";
import { Art57NodeUtils } from "../Art57Node/Art57NodeUtils";
import { BaseNode } from "../BaseNode";
import { ResultList } from "../ListEntity/ResultList";
import { QueryFieldsNode } from "../QueryFieldsNode";
import { QueryNode } from "../QueryNode";
import { MedicinalProductsQueryResultNode } from "./MedicinalProductsQueryResultNode";
import { Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { ServiceEnum } from "../../ServiceEnum";
import { MedicinalproductsService } from "../../../service/medicinalproducts-service/medicinalproducts.service";
import { DateUtil } from "../../DateUtil";
import { QueryConditionsNode } from "../QueryConditionsNode";

export class MedicinalProductsQueryNode extends QueryNode {
    parentNodeClass?: new (...args: any[]) => any;
    createChildTemplateParams?: any;
    autoUploadEntityName?: string;

    /**
     * @param injector: Injector
     * @param data: Information retrieved from the backed normally represents the model
     * @param labelTemplate: Label Template for the node
     * @param entityName: Represents the entity name to be used to call Backend endpoint service
     * @param fields: Formly fields used by the class, normaly comes from medicinal products file fieldDefinition-fieldsFormly
     * @param conditions: formly conditions used by the class, normaly comes from medicinal products file fieldDefinition-conditions, 
     * @param entityNode: Entity node instance that represents the SipleSearchListNode that will be used to manage operations over class without search for it
     * @param parentNodeClass: Class name of the parent node where entities to be loaded will be load 
     * @param autoUploadEntityName: Class name for the Autoupload node to be used when load en entity
     * @param createChildTemplateParams Optional parameters to be used in createChildTemplate method for class specified in parentNodeClass when a new node is created using createXEVPRM function
     */
    constructor(injector: Injector, data: any, labelTemplate: string, entityName: string, fields: FormlyFieldConfig[], conditions: FormlyFieldConfig[], entityNode: BaseNode | null, parentNodeClass: new (...args: any[]) => any, autoUploadEntityName: string, createChildTemplateParams?: any) {
        super(injector, data, labelTemplate, fields, conditions, entityName, ServiceEnum.MedicinalProducts, entityNode);
        this.parentNodeClass = parentNodeClass;
        this.createChildTemplateParams = createChildTemplateParams;
        this.autoUploadEntityName = autoUploadEntityName;
    }

    /**
     * 
     * @param pageToRetrieve Pagination control with information of the pagination used to retrieve the results 
     * @param nodeRequest Node that made the request for these results
     * @param data Refers to the model information that will be used in creation of DynamicListView element
     */
    override processResult(pageToRetrieve: PaginationControl, nodeRequest: BaseNode, data: any): void {
        let resultNodeList: TreeNode | null = Art57NodeUtils.findFirstChildNodeOfType(this, ResultList);
        let resultNode = null;
        if (resultNodeList) {
            if ((!(nodeRequest instanceof ResultList)) && (!(nodeRequest instanceof MedicinalProductsQueryResultNode))) {
                // This is the RUN scenario
                if (data && (data.length > 0)) {
                    const fieldsNode: QueryFieldsNode = (Art57NodeUtils.findFirstChildNodeOfType(this, QueryFieldsNode) as QueryFieldsNode);
                    const conditionsNode: QueryConditionsNode = (Art57NodeUtils.findFirstChildNodeOfType(this, QueryConditionsNode) as QueryConditionsNode);
                    const listViewInstance = new DynamicListView(data, fieldsNode.getFieldsToShow());
                    resultNode = new MedicinalProductsQueryResultNode(this.ioc!, listViewInstance, "Result " + DateUtil.getResultDateTime(), this.entityName, fieldsNode, conditionsNode);
                    resultNode.paginationControl = pageToRetrieve;
                    resultNode.parent = resultNodeList;
                    resultNode.lastData = data;
                    resultNodeList.children?.push(resultNode);
                    this.ioc!.get(SectionService).selectMedicinalProductsNode(resultNode);
                }
            } else {
                // This is the RERUN scenario
                nodeRequest.data.model = data.map((info: any) => ({ checked: false, ...info }));;
                resultNode = nodeRequest;
                this.ioc!.get(SectionService).selectMedicinalProductsNode(resultNode);
            }

        }
    }

    getRecordsToExcel(pageToRetrieve: any, isExport: boolean) {
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel file...', life: environment.successElapsedTime });

        if (pageToRetrieve == null) {
            pageToRetrieve = new PaginationControl();
            pageToRetrieve.setFields(this.getFields());
            pageToRetrieve.setCriteria(this.getConditions());
        }

        this.ioc!.get(MedicinalproductsService).filterToExcel(this.entityName, pageToRetrieve.criteria, pageToRetrieve.currentPage, false, isExport, pageToRetrieve.fields)
            .subscribe((response: any) => {
                const contentDisposition = response.headers.get('content-disposition');
                const filename = contentDisposition.match(/filename=(.+)$/)[1].replace(/['"]/, '').trim();
                const url = window.URL.createObjectURL(response.body as Blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel finished', life: environment.successElapsedTime });
            }, (error: any) => {
                this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                throw error;
            });
    }

    executeQueryToExcel() {
        this.getRecordsToExcel(null, false);
    }

    exportToExcel() {
        this.getRecordsToExcel(null, true);
    }



}